/*
App container view
*/
export default class App extends React.Component {
	constructor(props){
		super(props);
		//this.state = {};

	}

  render() {
    return (
  	  <div id="react-app-container">
        {this.props.children}
  	  </div>
      );
    }
};



// WEBPACK FOOTER //
// src/js/view/app.jsx